<script setup lang="ts">
    import { computed } from 'vue'
    import { useClipboard } from '@vueuse/core'

    const props = defineProps<{
        part: unknown
    }>()

    const { copy, copied } = useClipboard()

    const toolPart = computed(() => {
        const part = props.part as {
            output?: {
                subject: string
                body: string
            }
        }
        return part
    })
    const openEmailClient = () => {
        if (!toolPart.value.output) {
            return
        }
        const mailtoLink = `mailto:?subject=${encodeURIComponent(
            toolPart.value.output.subject,
        )}&body=${encodeURIComponent(toolPart.value.output.body)}`
        window.open(mailtoLink)
    }
</script>

<template>
    <div class="border border-surface-3 rounded-xl w-full overflow-hidden">
        <div
            class="px-sm py-6 bg-surface-1 text-12 border-b border-surface-3 text-word-3 flex items-center gap-8">
            <VvIcon name="ri:mail-line" class="text-16" />
            <strong class="font-bold">
                {{ $t('label.email') }}
            </strong>
            <VvButtonGroup modifiers="compact" class="ml-auto shrink-0">
                <VvButton
                    modifiers="action-quiet-small"
                    :icon="copied ? 'ri:check-line' : 'ri:file-copy-line'"
                    :label="copied ? $t('action.copied') : $t('action.copy')"
                    @click="
                        copy(
                            `${toolPart?.output?.subject}\n\n${toolPart?.output?.body}`,
                        )
                    " />
                <VvButton
                    icon="ri:mail-send-line"
                    modifiers="action-quiet-small"
                    :title="$t('action.openInEmailClient')"
                    :label="$t('action.send')"
                    @click="openEmailClient" />
            </VvButtonGroup>
        </div>
        <div class="border-b border-surface-3 p-sm">
            <div class="text-12 text-word-4 mb-4">
                {{ $t('label.subject') }}
            </div>
            <div class="text-word-2 font-semibold">
                {{ toolPart?.output?.subject }}
            </div>
        </div>
        <div class="p-sm">
            <div class="text-12 text-word-4 mb-4">
                {{ $t('label.body') }}
            </div>
            <pre class="text-word-2 whitespace-pre-wrap break-words">{{
                toolPart?.output?.body
            }}</pre>
        </div>
    </div>
</template>
